module.exports = __webpack_public_path__ + "static/flags/nl-5d5914bdb15f5d1e5be73645d6910a9e.svg";